<template>
  <div class="w-full p-5">
    <vx-card v-if="loading"> Loading </vx-card>
    <vx-card title="Detail Surat" v-else>
      <div class="h2 text-danger" v-if="notFound">Data tidak ditemukan</div>
      <div class="w-full" v-else>
        <div class="w-full flex flex-col">
          <div class="font-bold">Nomor Surat</div>
          <div>
            {{ dokumen.nomor }}
          </div>
          <vs-divider></vs-divider>
        </div>
        <div class="w-full flex flex-col">
          <div class="font-bold">Perihal</div>
          <div>
            {{ dokumen.perihal }}
          </div>
          <vs-divider></vs-divider>
        </div>

        <div class="w-full flex flex-col">
          <div class="font-bold">Tanggal Surat</div>
          <div>
            {{ dokumen.tanggal_surat | indonesian_date }}
          </div>
          <vs-divider></vs-divider>
        </div>
        <!-- <div class="w-full flex flex-col" v-if="dokumen.sifat_surat_id == 1">
          <div class="font-bold mb-3">Surat</div>
          <div>
            <vs-button
              icon="icon-download"
              icon-pack="feather"
              @click="showFile(dokumen.surat.file_url)"
              >Download Surat</vs-button
            >
          </div>
          <vs-divider></vs-divider>
        </div>
        <div class="w-full flex flex-col" v-if="dokumen.sifat_surat_id == 1">
          <div class="font-bold mb-3">Lampiran</div>
          <div v-if="dokumen.lampiran.length > 0">
            <vs-button
              icon="icon-download"
              icon-pack="feather"
              v-for="(item, index) in dokumen.lampiran"
              @click="showFile(item.file_url)"
              :key="index"
              >Download Lam[iran</vs-button
            >
          </div>
          <div v-else>Tidak ada lampiran</div>
          <vs-divider></vs-divider>
        </div> -->
      </div>
    </vx-card>
  </div>
</template>

<script>
// import pdf from "vue-pdf";
import { digofHttp as axios } from "@/axios";

export default {
  data() {
    return {
      uuid: this.$route.params.id,
      loading: false,
      notFound: false,
      dokumen: {
        lampiran: [],
      },
    };
  },
  mounted() {
    this.fetchDokumen();
  },
  methods: {
    async fetchDokumen() {
      try {
        this.loading = false;
        const response = await axios({
          url: `upload/lihat-dokumen-general/${this.uuid}`,
          methods: "GET",
        });
        this.loading = false;
        this.dokumen = response.data.data.dokumen;
        this.notFound = false;
      } catch (e) {
        this.notFound = true;
      }
    },
    showFile(url) {
      window.open(url, "__blank");
    },
  },
};
</script>
